import { compose } from 'ramda';
import { withHandlers, withState } from 'recompose';

const AppSettingsContainer = compose(
  withState('activeTab', 'setActiveTab', 0),
  withHandlers({
    openRemotes: props => () => {
      const answer = prompt('Enter security code');
      const isBestSecurityCheckPassed = answer === 'beeboop';

      if (isBestSecurityCheckPassed) {
        props.setActiveTab(1);
      }
    },
  }),
);

export default AppSettingsContainer;
